// extracted by mini-css-extract-plugin
module.exports = {"historyTable":"FranchiseHistoryModal_historyTable__rk5pI","helperText":"FranchiseHistoryModal_helperText__1KG3q"};